// Re-exported from checkout-core (single source of truth for the quick-checkout x-cart-type check).
import { isQuickCheckoutFlow } from "@swiggy-private/checkout-core";

/**
 * Whether CheckoutApp's pre-CSS bootstrap shell should render the QC shimmer.
 *
 * - Static QC HTML sets `isQuickCheckoutCartFlow` (no `x-cart-type` at build time).
 * - Runtime hydrate uses native headers with `x-cart-type` after the synthetic header is gone.
 * Does not mean the session is in quick-checkout flow for routing / place-order / nav.
 */
export const shouldShowQuickCheckoutShimmer = (headers?: {
    [header: string]: string | undefined;
    // should move to isQuickCheckoutCartFlow header only check in follow up enhancements to keep this flag as a pre-hydrate and pre-CSS check
}): boolean => headers?.["isQuickCheckoutCartFlow"] === "true" || isQuickCheckoutFlow(headers);
